import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Breadcrumbs } from "@/components/Breadcrumbs";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen px-4 py-8">
      <div className="container mx-auto">
        <Breadcrumbs />
        <div className="flex min-h-screen items-center justify-center bg-gradient-subtle px-4 -mt-32">
          <div className="text-center max-w-md">
            <h1 className="mb-4 text-6xl sm:text-8xl font-bold text-primary">404</h1>
            <p className="mb-6 text-lg sm:text-xl text-muted-foreground">Oops! Page not found</p>
            <p className="mb-8 text-sm text-muted-foreground">The page you're looking for doesn't exist or has been moved.</p>
            <div className="space-y-3">
              <Button onClick={() => navigate(-1)} variant="outline" className="w-full">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Go Back
              </Button>
              <Button onClick={() => navigate('/')} className="w-full">
                Return to Home
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
